export default __webpack_public_path__ + "static/media/status-based-loitering-info.e4f78c18.png";